import { render, staticRenderFns } from "./AdminCashierElement.vue?vue&type=template&id=0954153b&scoped=true"
import script from "./AdminCashierElement.vue?vue&type=script&lang=js"
export * from "./AdminCashierElement.vue?vue&type=script&lang=js"
import style0 from "./AdminCashierElement.vue?vue&type=style&index=0&id=0954153b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0954153b",
  null
  
)

export default component.exports